<template>
  <div v-if="!loaderActiveForLogout" class="page-header align-items-start min-vh-100 mbr-signin" tabindex="-1">
    <span class="mask bg-white"></span>

    <section v-if="isLoginNormal" class="mbr-signin__entry">
      <div class="mbr-signin__hero" :class="{ 'mbr-signin__hero--image': loginBgImage }" :style="loginBgStyle">
        <div class="mbr-signin__brand">
          <img
            v-if="$store.state.merchantLogo"
            :src="$store.state.merchantLogo"
            class="mbr-signin__logo"
            :alt="$t('home.merchant_logo')"
          />
          <img
            v-else
            src="../assets/img/logo.png"
            class="mbr-signin__logo"
            :alt="$t('home.merchant_logo')"
          />
          <div>
            <span v-if="merchantBrandName" class="mbr-signin__brand-name">{{ merchantBrandName }}</span>
            <span class="mbr-signin__brand-tag">{{ $t('signin.members') }}</span>
          </div>
        </div>
      </div>

      <div class="mbr-signin__sheet">
        <span class="mbr-signin__handle" aria-hidden="true"></span>

        <label class="mbr-signin__label" for="phone_number">{{ $t('signin.mobile_number') }}</label>
        <div class="mbr-signin__phone">
          <select
            id="country_id"
            v-model="form1.phone_code"
            class="mbr-signin__code"
            :aria-label="$t('signin.country_code')"
            :disabled="checkAllowForeignerPhoneNumber == 'false' || checkAllowForeignerPhoneNumber == false"
          >
            <option v-for="(value, key) in phoneCodeOptions" :key="key" :value="value.value">
              {{ value.label }}
            </option>
          </select>
          <span class="mbr-signin__divider" aria-hidden="true"></span>
          <input
            id="phone_number"
            v-model="form1.phone_number"
            type="tel"
            name="phone_number"
            class="mbr-signin__number"
            autocomplete="nope"
            @change="validatePhoneNumber($event)"
          />
        </div>
        <p class="mbr-signin__hint">{{ $t('signin.phone_hint') }}</p>

        <material-button size="lg" full-width class="mbr-signin__cta" @click="validatePhone()">
          <span>{{ $t('common.continue') }}</span>
          <i class="material-icons-round" aria-hidden="true">arrow_forward</i>
        </material-button>
        <button v-if="branch_code != ''" type="button" class="mbr-signin__guest" @click="continueAsGuest()">
          {{ $t('signin.continue_as_guest') }}
        </button>

        <template v-if="!onlyAllowExistingMemberMooLogin">
          <div class="mbr-signin__or"><span>{{ $t('signin.or') }}</span></div>
          <SocialLogin />
        </template>

        <i18n-t :keypath="merchantBrandName ? 'signin.legal_brand' : 'signin.legal_our'" tag="p" scope="global" class="mbr-signin__legal">
          <template #brand>{{ merchantBrandName }}</template>
          <template #terms>
            <button type="button" class="mbr-signin__link" @click="openLegal('terms-service')">{{ $t('signin.terms') }}</button>
          </template>
          <template #privacy>
            <button type="button" class="mbr-signin__link" @click="openLegal('privacy-policy')">{{ $t('signin.privacy_policy') }}</button>
          </template>
        </i18n-t>
      </div>
    </section>

    <div class="notifications">
      <material-alert
        v-if="error"
        color="danger"
        icon="ni ni-like-2 ni-lg"
        dismissible
      >
        {{ error }}
      </material-alert>
    </div>

    <section v-if="!isLoginNormal" class="mbr-signin__step">
      <div class="mbr-signin__topbar">
        <button type="button" class="mbr-signin__back" :aria-label="$t('common.back')" @click="handleBack()">
          <i class="material-icons-round" aria-hidden="true">chevron_left</i>
        </button>
        <div v-if="form1.phone_number" class="mbr-signin__who">
          <span>+{{ form1.phone_code }} {{ displayPhoneNumber }}</span>
          <button type="button" class="mbr-signin__change" @click="backToPhone()">{{ $t('signin.change') }}</button>
        </div>
      </div>

      <div class="mbr-signin__body" :class="{ 'mbr-signin__body--top': isResetStep }">
        <template v-if="isAlreadyPasscode && !isForgetPassword && !isShowEnterPasscodeYourBirtday && !isShowEnterOneTimePasscode">
          <div>
            <h1 class="mbr-signin__title">{{ $t('signin.enter_passcode_title') }}</h1>
            <p class="mbr-signin__sub">{{ $t('signin.enter_passcode_sub') }}</p>
          </div>
          <div id="enterPasscode" class="mbr-signin__pin">
            <passcode-pin
              ref="inputEnterPasscode"
              :should-auto-focus="true"
              :aria-label="$t('passcode.passcode')"
              @on-change="handleOnChange"
              @on-complete="handleOnCompleteAlreadyPasscode"
              v-model="form2.passcode"
            />
          </div>
          <button type="button" class="mbr-signin__textlink" @click="handleEnbaleOptionForgotPasscode()">
            {{ $t('signin.forgot_passcode') }}
          </button>
        </template>

        <template v-if="isPasscode">
          <div>
            <h1 class="mbr-signin__title mbr-signin__title--sm">{{ $t('passcode.create_title') }}</h1>
            <p class="mbr-signin__sub">{{ $t('passcode.create_sub') }}</p>
          </div>
          <div id="enterCreatePasscode" class="mbr-signin__pin">
            <passcode-pin
              ref="inputCreatePasscode"
              :should-auto-focus="true"
              :aria-label="$t('passcode.new_passcode')"
              @on-change="handleOnChange"
              @on-complete="handleOnCompletePasscode"
              v-model="form2.passcode"
            />
          </div>
        </template>

        <template v-if="isConfirmPasscode">
          <div>
            <h2 class="mbr-signin__title mbr-signin__title--sm">{{ $t('passcode.confirm_title') }}</h2>
            <p class="mbr-signin__sub">{{ $t('passcode.confirm_sub') }}</p>
          </div>
          <div id="inputConfirmPasscode" class="mbr-signin__pin">
            <passcode-pin
              ref="inputConfirmPasscode"
              :should-auto-focus="false"
              :aria-label="$t('passcode.confirm_passcode')"
              @on-change="handleOnChange"
              @on-complete="handleOnCompleteConfirmPasscode"
              v-model="form2.confirmPasscode"
            />
          </div>
        </template>

        <template v-if="isOtp">
          <div>
            <h1 class="mbr-signin__title">{{ $t('signin.otp_title') }}</h1>
            <p class="mbr-signin__sub">{{ $t('signin.otp_sub', { phone: '+' + form1.phone_code + ' ' + displayPhoneNumber }) }}</p>
          </div>
          <div id="otp" class="mbr-signin__pin">
            <v-otp-input
              ref="inputOTP"
              input-classes="otp-input"
              separator=""
              :num-inputs="4"
              :should-auto-focus="true"
              :is-input-num="true"
              :conditionalClass="['one', 'two', 'three', 'four']"
              :placeholder="['', '', '', '']"
              @on-change="handleOnChange"
              @on-complete="handleOnComplete"
              v-model="form2.otp"
            />
          </div>
          <div class="mbr-signin__inline mbr-signin__resend">
            <button type="button" class="mbr-signin__textlink" @click="sendOTP(true)">{{ $t('signin.resend_otp') }}</button>
            <span class="mbr-signin__countdown" v-html="countDownText"></span>
          </div>
        </template>

        <!-- MBR018: one-time passcode is not offered here (still linked from the birthday step) -->
        <template v-if="isResetStep">
          <div class="mbr-signin__emblem" aria-hidden="true">
            <span class="mbr-signin__emblem-glow"></span>
            <span class="mbr-signin__emblem-frame">
              <span class="mbr-signin__emblem-core">
                <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
                  <rect height="11" rx="2" ry="2" width="18" x="3" y="11" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                  <circle cx="12" cy="16" fill="currentColor" r="1.2" />
                </svg>
              </span>
            </span>
          </div>
          <div class="mbr-signin__reset-head">
            <h1 class="mbr-signin__title mbr-signin__reset-title">{{ $t('signin.reset_title') }}</h1>
            <p class="mbr-signin__reset-sub">
              {{ $t('signin.reset_sub') }}
            </p>
          </div>
          <div class="mbr-signin__reset-actions">
            <!-- Always enabled: the merchant's allow_reset_passcode_to_birthday flag no longer gates this CTA -->
            <material-button
              size="lg"
              full-width
              class="mbr-signin__reset-cta"
              @click="gotoResetToInitialPasscode()"
            >
              <span>{{ $t('signin.reset_cta') }}</span>
              <i class="material-icons-round" aria-hidden="true">chevron_right</i>
            </material-button>
            <div class="mbr-signin__ddmm">
              <span class="mbr-signin__ddmm-icon" aria-hidden="true">
                <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.6" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" x2="12" y1="16" y2="12" />
                  <line x1="12" x2="12.01" y1="8" y2="8" />
                </svg>
              </span>
              <div class="mbr-signin__ddmm-text">
                <p><strong>*DD:</strong> {{ $t('signin.ddmm_day') }}</p>
                <p><strong>MM:</strong> {{ $t('signin.ddmm_month') }}</p>
                <i18n-t keypath="signin.ddmm_example" tag="p" scope="global" class="mbr-signin__ddmm-example">
                  <template #label><strong>{{ $t('signin.example') }}</strong></template>
                  <template #code><span class="mbr-signin__ddmm-code">0201</span></template>
                </i18n-t>
              </div>
            </div>
          </div>
        </template>

        <template v-if="isAlreadyPasscode && isShowEnterPasscodeYourBirtday">
          <h1 class="mbr-signin__title mbr-signin__title--sm">{{ $t('signin.birthday_title') }}</h1>
          <form role="form" class="mbr-signin__form">
            <div id="otp" class="mbr-signin__pin">
              <passcode-pin
                ref="inputOTP"
                :should-auto-focus="true"
                :aria-label="$t('passcode.birthday_ddmm')"
                @on-change="handleOnChange"
                @on-complete="handleOnCompleteAlreadyPasscode"
                v-model="form2.passcode"
              />
            </div>
          </form>
          <div class="mbr-signin__inline">
            <span>{{ $t('signin.forgot_birthday') }}</span>
            <button
              v-if="!isEnableGetOneTimePasscode && (checkAllowResetPasscodeToOneTimeOtp == 'true' || checkAllowResetPasscodeToOneTimeOtp == true)"
              type="button"
              class="mbr-signin__textlink"
              @click="handleGetOneTimePasscode()"
            >
              {{ $t('signin.get_one_time_passcode') }}
            </button>
          </div>
          <div class="mbr-signin__note">
            <i class="material-icons-round" aria-hidden="true">info_outline</i>
            <span>*DD: {{ $t('signin.ddmm_day') }}<br />MM: {{ $t('signin.ddmm_month') }}</span>
          </div>
        </template>

        <template v-if="isAlreadyPasscode && isShowEnterOneTimePasscode">
          <h1 class="mbr-signin__title mbr-signin__title--sm">{{ $t('signin.one_time_title') }}</h1>
          <form role="form" class="mbr-signin__form">
            <div id="otp" class="mbr-signin__pin">
              <v-otp-input
                ref="inputOTP"
                input-classes="otp-input"
                separator=""
                :num-inputs="4"
                :should-auto-focus="true"
                :is-input-num="true"
                :conditionalClass="['one', 'two', 'three', 'four']"
                :placeholder="['', '', '', '']"
                @on-change="handleOnChange"
                @on-complete="handleOnCompleteAlreadyPasscode"
                v-model="form2.passcode"
              />
            </div>
          </form>
        </template>
      </div>
      <!-- The mockup's "Contact Member Support" link is omitted: /contact-us rejects logged-out members (checkMemberPermissions → back to sign-in) -->
      <footer v-if="isResetStep && merchantBrandName" class="mbr-signin__support">
        <p class="mbr-signin__support-brand">
          <span aria-hidden="true"></span>{{ merchantBrandName }}<span aria-hidden="true"></span>
        </p>
      </footer>
      <passcode-keypad v-if="showKeypad" class="mbr-signin__keypad" />
    </section>
    <div class="position-fixed top-1 end-1 z-index-2" style="z-index: 10001 !important;">
      <material-snackbar v-if="snackbar === 'danger' || snackbar === 'success'" title="" date=""
                :description="message" :icon="{ component: 'campaign', color: 'white' }" :color="snackbar"
                :close-handler="closeSnackbar" />
      <!-- <material-snackbar
        v-if="snackbar === 'danger'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        color="danger"
        :close-handler="closeSnackbar"
      /> -->
    </div>
    <material-loading :active="loaderActive" />
    <TermService :iAgree="form1.i_agree" :phone="form1.phone_number" :changeCheckboxAgree="changeCheckboxAgree" :agree="agree" />
    <ModalSuccess :processAcction="closeModal" :success="false"
      :message="modalErrorMessage" :buttonText="$t('common.ok')" />
  </div>
</template>

<script>
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialAlert from "@/components/MaterialAlert.vue";
import { mapMutations } from "vuex";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import VOtpInput from "vue3-otp-input";
import SocialLogin from "@/components/SocialLogin";
import router from "@/router";
import TermService from "@/components/TermService.vue";
import AuthService from "../services/auth.service";
import { useRoute } from 'vue-router'
import { ref } from "vue";
import $ from "jquery";
import TokenService from "../services/token.service";
import MemberService from "../services/member.service";
import CryptoJS from 'crypto-js';
import axios from "axios";
import { backToOnlineOrdering, localStorageName } from '@/config/utils.js';
import { filterPhoneCodes } from '@/config/phoneCodes.js';
import ModalSuccess from "@/components/ModalSuccess.vue";
import PasscodePin from "@/components/PasscodePin.vue";
import PasscodeKeypad from "@/components/PasscodeKeypad.vue";
import { errorMessage } from "@/utils/errorMessage";

export default {
  name: "sign-in",
  components: {
    MaterialButton,
    MaterialAlert,
    MaterialSnackbar,
    VOtpInput,
    SocialLogin,
    MaterialLoading,
    TermService,
    ModalSuccess,
    PasscodePin,
    PasscodeKeypad
  },
  setup() {
    const inputOTP = ref(null);
    const inputEnterPasscode = ref(null);
    const inputCreatePasscode = ref(null);
    const inputConfirmPasscode = ref(null);

    const clearInputOTP = () => {
      inputOTP.value.clearInput();
    };
    const clearInputEnterPasscode = () => {
      inputEnterPasscode.value.clearInput();
    };
    const clearInputCreatePasscode = () => {
      inputCreatePasscode.value.clearInput();
    };
    const clearInputConfirmPasscode = () => {
      inputConfirmPasscode.value.clearInput();
    };
    return { inputOTP, inputEnterPasscode, inputCreatePasscode, inputConfirmPasscode, clearInputOTP, clearInputEnterPasscode, clearInputCreatePasscode, clearInputConfirmPasscode };
  },
  data() {
    return {
      phone_code: "65",
      form1: {
        phone_number: "",
        invite_code: "",
        i_agree: false,
        phone_code: "65"
      },
      message: "",
      modalErrorMessage: "",
      form2: {
        otp: "",
        phone_number: "",
        i_agree: true,
        passcode: "",
        confirmPasscode: "",
        is_empty_passcode: false,
        phone_code: ""
      },
      snackbar: null,
      error: "",
      isLoginNormal: true,
      isPasscode: false,
      isConfirmPasscode: false,
      isAlreadyPasscode: false,
      isOtp: false,
      timerEnabled: true,
      countDown: 120,
      countDownText: "120s",
      timeout: "",
      timer_on: 0,
      merchantCode: "",
      loaderActive: false,
      isFirstLogin: false,
      branch_code: "",
      isForgetPassword: false,
      isShowEnterPasscodeYourBirtday: false,
      isShowEnterOneTimePasscode: false,
      checkAllowResetPasscodeToBirthday: null,
      checkAllowResetPasscodeToOneTimeOtp: null,
      isEnableGetOneTimePasscode: true,
      loaderActiveForLogout: false,
      countryData: [],
      checkAllowForeignerPhoneNumber: null,
      onlyAllowExistingMemberMooLogin: false,
      merchantBrandName: localStorage.getItem(localStorageName("MERCHANT_BRAND_NAME")) ?? "",
      // MBR133: background the merchant uploaded for this page; empty keeps the default hero.
      loginBgImage: localStorage.getItem(localStorageName("MBR_LOGIN_BG_IMAGE")) ?? "",
    };
  },
  beforeMount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  beforeUnmount() {
    this.loaderActiveForLogout = false;
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  created() {
    const onlyAllowExistingMemberMooLogin = localStorage.getItem(localStorageName("ONLY_ALLOW_EXISTING_MEMBER_MOO_LOGIN"));
    this.onlyAllowExistingMemberMooLogin = onlyAllowExistingMemberMooLogin == 'true' || onlyAllowExistingMemberMooLogin == '1' ? true : false;
    
    this.getCountriesForDropdown();
    const token = TokenService.getLocalAccessToken();
    const isLogout = this.$route.query.isLogout ?? '';
    const queue = this.$route.query.queue ?? false;
    const code = this.$router.currentRoute.value.params.merchant_code ?? "";
    const tableCode = this.$route.query.table_code ?? "";
    // localStorage.setItem("MERCHANT_CODE", code);
    var merchantCode = code ? `/${code}` : "";

    if(isLogout != "" && token) {
      this.loaderActiveForLogout = true;
      TokenService.removeUser();
      var url = process.env.VUE_APP_ONLINE_ORDERING_BY_BRANCH_URL+merchantCode;
      const sceen = queue ? 'queue' : 'order';

      if (tableCode) {
        url += "/QR/" + isLogout + "/" + tableCode + "/" + sceen;
      } else {
        url += "/" + isLogout + "/" + sceen;
      }
      
      window.open(url, "_self");
    }
  },
  mounted() {
    const isAllowResetPasscodeToBirthday = localStorage.getItem(localStorageName("ALLOW_RESET_PASSCODE_TO_BIRTHDAY"), 'false');
    const isAllowResetPasscodeToOneTimeOtp = localStorage.getItem(localStorageName("ALLOW_RESET_PASSCODE_TO_ONE_TIME_OTP"), 'false');
    const isAllowForeignerPhoneNumber = localStorage.getItem(localStorageName("ALLOW_FOREIGNER_PHONE_NUMBER"), 'false');
    
    this.checkAllowResetPasscodeToBirthday = isAllowResetPasscodeToBirthday;
    this.checkAllowResetPasscodeToOneTimeOtp = isAllowResetPasscodeToOneTimeOtp;
    this.checkAllowForeignerPhoneNumber = isAllowForeignerPhoneNumber;
    this.form1.invite_code =
      this.$router.currentRoute.value.params.invite_code ?? "";
    const code = this.$router.currentRoute.value.params.merchant_code ?? "";
    // localStorage.setItem("MERCHANT_CODE", code);
    this.merchantCode = code ? `/${code}` : "";
    const token = TokenService.getLocalAccessToken();
    const branch_code = this.$route.query.branch_code ?? '';
    // const isLogout = this.$route.query.isLogout ?? '';
    const table_code = this.$route.query.table_code ?? '';
    const from = this.$route.query.from ?? '';
    const queue = this.$route.query.queue ?? false;
    // if(isLogout != "" && token) {
    //   TokenService.removeUser();
    //   window.open(process.env.VUE_APP_ONLINE_ORDERING_BY_BRANCH_URL+this.merchantCode+"/"+isLogout+"/order","_self"); 
    // }
    if(branch_code != "") {
        this.branch_code = branch_code;
    }
    if (token && this.merchantCode) {
      if(branch_code != "") {
        AuthService.checkTokenHasExpired().then(
          (response) => {
            if (response.data.result.isSuccess) {
              var memberLogin = TokenService.getMember();
              backToOnlineOrdering(this.merchantCode, branch_code, token, memberLogin?.data.user.id, table_code, from, queue);
              // window.open(process.env.VUE_APP_ONLINE_ORDERING_BY_BRANCH_URL+this.merchantCode+"/"+branch_code+"?key="+token+"&memberId="+ memberLogin?.data.user.id+"&from="+ from, '_self'); 
            }
          },
          (error) => {
            console.log(error);
          }
        )
      } else {
        router.push(this.merchantCode + "/home");
      }
    }

    const route = useRoute()

    if (route.query.phone) {
      this.form1.phone_number = route.query.phone;
      $('.bottom_modal_terms').click();
    }
  },
  computed: {
    loginBgStyle() {
      return this.loginBgImage ? { '--mbr-login-bg': `url(${JSON.stringify(this.loginBgImage)})` } : null;
    },
    phoneCodeOptions() {
      return filterPhoneCodes(this.countryData, this.form1.phone_code);
    },
    // 8-digit numbers read as "8933 7333"; any other length is shown as typed
    displayPhoneNumber() {
      const number = this.form1.phone_number ?? "";
      return /^\d{8}$/.test(number) ? `${number.slice(0, 4)} ${number.slice(4)}` : number;
    },
    isResetStep() {
      return this.isAlreadyPasscode && this.isForgetPassword;
    },
    // Number pad on passcode entry (enter / create / confirm / birthday DDMM); OTP and
    // one-time passcode keep the system keyboard so SMS autofill still works
    showKeypad() {
      if (this.isLoginNormal || this.isOtp) return false;
      if (this.isPasscode || this.isConfirmPasscode) return true;
      return this.isAlreadyPasscode && !this.isForgetPassword && !this.isShowEnterOneTimePasscode;
    },
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    showErrorModal(message) {
      this.modalErrorMessage = message;
      this.$nextTick(() => {
        $('.btn-success-modal').click();
      });
    },
    validatePhone: async function () {
      this.closeSnackbar()
      this.showLoader()
      var merchantId = localStorage.getItem(localStorageName('MERCHANT_ID'), 0);
      var merchantCode = this.$route.params.merchant_code ?? '';

      if (merchantId == 0 && merchantCode != '') {
        await MemberService.getMerchantId({
          merchant_code: merchantCode
        })
        .then(
          (response) => {
            if (response.data.result.isSuccess) {
              merchantId = response.data.data.merchantId;
              axios.defaults.headers.common['MerchantId'] = merchantId;
              localStorage.setItem(localStorageName('MERCHANT_ID'), merchantId);
            } else {
              this.snackbar = 'danger'
              this.message = errorMessage(response.data.result.message)
              this.setTimeOutNotification()
            }
          },
          (error) => {
            this.snackbar = 'danger'
            this.message = errorMessage(error)
            this.hideLoader()
          }
        )
      }

      if (merchantId) {
        await AuthService.validatePhoneNumber(this.form1.phone_number, this.form1.phone_code).then(
          (response) => {
            if (response.data.result.isSuccess) {
              if(response.data.data.is_first_login && response.data.data.is_empty_passcode) {
                // first time login
                if (this.onlyAllowExistingMemberMooLogin) {
                  this.showErrorModal(this.$t("signin.member_not_found") + "<br>" + this.$t("signin.use_member_portal"));
                } else {
                  $(".bottom_modal_terms").click();
                  this.isFirstLogin = true
                  this.form2.is_empty_passcode = response.data.data.is_empty_passcode;
                }
              } else {
                this.isLoginNormal = false;
                this.isFirstLogin = false
                this.form1.i_agree = true
                this.isOtp = false;
                if(!response.data.data.is_empty_passcode) {
                  this.isAlreadyPasscode = true;
                  this.isPasscode = false;
                  this.isConfirmPasscode = false;
                } else {
                  this.isAlreadyPasscode = false;
                  this.isPasscode = true;
                  this.isConfirmPasscode = true;
                }
                this.form2.phone_number = this.form1.phone_number;
                this.form2.is_empty_passcode = response.data.data.is_empty_passcode;
                // this.sendOTP()
              }
            } else {
              this.snackbar = 'danger'
              this.message = errorMessage(response.data.result.message)
              this.setTimeOutNotification()
            }
            this.hideLoader()
          },
          (error) => {
            this.snackbar = 'danger'
            this.message = errorMessage(error)
            this.hideLoader()
          }
        )
      }
    },
    changeCheckboxAgree() {
      this.form1.i_agree = !this.form1.i_agree
    },
    agree() {
      if(!this.form1.i_agree) {
        this.snackbar = 'danger'
        this.message = this.$t("signin.terms_required")
        this.setTimeOutNotification()
      } else {
        this.sendOTP()
      }
    },
    validatePhoneNumber() {
      this.form1.phone_number = this.form1.phone_number.replaceAll(' ', '');
      this.form1.phone_number = this.form1.phone_number.replaceAll('+65', '');
    },
    sendOTP: function (isResend = false) {
      var _this = this;
      _this.closeSnackbar();
      _this.stopCount();
      _this.$store.dispatch("auth/sendOtp", _this.form1).then(
        (data) => {
          $(".btn-close").click();
          if (data != undefined && !data.result.isSuccess) {
            _this.message = errorMessage(data.result.message);
            _this.snackbar = "danger";
          } else {
            if (isResend == true) {
              _this.message = errorMessage(data.result.message);
            }
            _this.form2.phone_number = _this.form1.phone_number;
            _this.isLoginNormal = false;
            var sending_otp_signup = localStorage.getItem(localStorageName("SENDING_OTP_SIGNUP"), 0);
            if(sending_otp_signup == 1 || sending_otp_signup == '1') {
              if(this.form1.phone_code == '65') {
                _this.isOtp = true;
                _this.countDown = 120;
                _this.startCount();
              } else {
                _this.isPasscode = true;
                _this.isConfirmPasscode = true;
              }
            } else {
              _this.isPasscode = true;
              _this.isConfirmPasscode = true;
            }
          }
          _this.setTimeOutNotification();
        },
        (error) => {
          console.log("ERROR" + error);
        }
      );
    },
    loginOtp: function () {
      var _this = this;
      AuthService.validateOtp({ phone_number: this.form2.phone_number, otp: this.form2.otp }).then(
        (response) => {
          if (response.result.isSuccess) {
            // console.log("response.data.data", response.data);
            // enter
            _this.isOtp = false;
            _this.isPasscode = true;
            _this.isConfirmPasscode = true;
          } else {
            this.snackbar = 'danger'
            this.message = errorMessage(response.result.message)
            this.setTimeOutNotification();
            _this.clearInputOTP();
          }
          this.hideLoader()
        },
        (error) => {
          this.snackbar = 'danger'
          this.message = errorMessage(error)
          this.hideLoader()
        }
      )
    },
    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
    handleOnComplete(value) {
      this.form2.otp = value;
      this.loginOtp();
    },
    closeSnackbar() {
      this.snackbar = null;
    },
    timedCount() {
      if (this.countDown > 0) {
        this.countDown -= 1;
        this.countDownText = `${this.countDown} s`;
        this.timeout = setTimeout(this.timedCount, 1000);
      }
    },
    startCount() {
      if (!this.timer_on) {
        this.timer_on = 1;
        this.timedCount();
      }
    },
    stopCount() {
      clearTimeout(this.timeout);
      this.countDown = 120;
      this.timer_on = 0;
    },
    callback: function (response) {
      console.log("Handle the response", response);
    },
    showSnackbarError() {
      this.snackbar = "danger";
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
    handleOnCompletePasscode: function (value) {
      if(value != "") {
        this.form2.passcode = value;
        this.form2.confirmPasscode = "";
        this.form2.phone_code = this.form1.phone_code;
        setTimeout(() => {
          this.clearInputConfirmPasscode();
        }, 500);
      } else {
        this.form2.passcode = "";
        this.form2.confirmPasscode = "";
        setTimeout(() => {
          this.clearInputConfirmPasscode();
        }, 500);
      }
      this.$nextTick(() => {
        this.$refs.inputConfirmPasscode.$el.querySelector('input').focus();
      });
      // this.isPasscode = false;
      // this.isConfirmPasscode = true;
    },
    handleOnCompleteConfirmPasscode: function (value) {
      if(value === this.form2.passcode) {
        this.handleLogin();
      } else {
        this.snackbar = 'danger'
        this.message = this.$t("signin.passcode_mismatch")
        this.setTimeOutNotification();
        setTimeout(() => {
          this.clearInputConfirmPasscode();
        }, 500);
      }
    },
    handleOnCompleteAlreadyPasscode: function (value) {
      this.form2.passcode = value;
      this.form2.phone_code = this.form1.phone_code;
      this.handleLogin();
    },
    handleLogin() {
      var _this = this;
      _this.closeSnackbar();
      _this.showLoader();
      _this.$store.dispatch("auth/loginOtp", this.form2).then(
        (data) => {
          if (data != undefined && !data.result.isSuccess) {
            this.hideLoader();
            _this.message = errorMessage(data.result.message);
            _this.showSnackbarError();
            // _this.clearInputOTP();
            setTimeout(() => {
              _this.clearInputEnterPasscode();
            }, 500);
            // _this.clearInputCreatePasscode();
            // _this.clearInputConfirmPasscode();
          } else {
            // save passcode using encrypt
            this.encryptData(this.form2.passcode);
            var memberLogin = TokenService.getMember();
            _this.isLoginNormal = false;
            if(_this.isFirstLogin) {
              const branch_code = this.$route.query.branch_code ?? '';
              const table_code = this.$route.query.table_code ?? '';
              const from = this.$route.query.from ?? '';
              const queue = this.$route.query.queue ?? false;

              let profileUrl = this.merchantCode + "/profile";
              const queryParams = [];
              if(branch_code) queryParams.push(`branch_code=${branch_code}`);
              if(table_code) queryParams.push(`table_code=${table_code}`);
              if(from) queryParams.push(`from=${from}`);
              if(queue) queryParams.push(`queue=${queue}`);

              if(queryParams.length > 0) {
                profileUrl += "?" + queryParams.join("&");
              }

              router.push(profileUrl);
            } else {
              const branch_code = this.$route.query.branch_code ?? '';
              const table_code = this.$route.query.table_code ?? '';
              const from = this.$route.query.from ?? '';
              const queue = this.$route.query.queue ?? false;

              if(branch_code != "") {
                const token = TokenService.getLocalAccessToken();
                if (token && this.merchantCode) {
                  backToOnlineOrdering(this.merchantCode, branch_code, token, memberLogin?.data.user.id, table_code, from, queue);
                  // window.open(process.env.VUE_APP_ONLINE_ORDERING_BY_BRANCH_URL+this.merchantCode+"/"+branch_code+"?key="+token+"&memberId="+ memberLogin?.data.user.id+"&from="+ from, '_self');
                }
              } else {
                if(this.isShowEnterOneTimePasscode) {
                  router.push(this.merchantCode + "/home?memorize=1");
                } else {
                  router.push(this.merchantCode + "/home");
                }
              }
            }
          }
          _this.hideLoader();
        },
        (error) => {
          // _this.clearInputOTP();
          setTimeout(() => {
            _this.clearInputEnterPasscode();
          }, 500);
          // _this.clearInputCreatePasscode();
          // _this.clearInputConfirmPasscode();
          console.log("ERROR" + error);
        }
      );
    },
    handleEnbaleOptionForgotPasscode() {
      // App.vue already loaded get-merchant-setting before this view mounted
      if (this.$store.state.hasWaBalance) {
        this.isEnableGetOneTimePasscode = false;
      }
      this.isForgetPassword = true;
    },
    handleForgotPassword() {
      this.closeSnackbar()
      this.showLoader()
      var link = window.location.origin+this.merchantCode+"/forget-passcode";
      AuthService.sendLinkForgotPasscode(this.form1.phone_number, link).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = 'success';
            this.message = this.$t("signin.passcode_sent");
            this.setTimeOutNotification();
          } else {
            this.snackbar = 'danger'
            this.message = errorMessage(response.data.result.message)
            this.setTimeOutNotification()
          }
          this.hideLoader()
        },
        (error) => {
          this.snackbar = 'danger'
          this.message = errorMessage(error)
          this.hideLoader()
        }
      )
    },
    encryptData(passcode) {
      if (passcode) {
          const encryptedData = CryptoJS.AES.encrypt(passcode, process.env.VUE_APP_KEY_ENCRYPT_MEMBER_INFORMATION).toString();
          localStorage.setItem(localStorageName('MEMBER_PASSCODE'), encryptedData ?? '');
      }
    },
    continueAsGuest() {
      if(this.branch_code != "") {
        const table_code = this.$route.query.table_code ?? '';
        let from = '/order';

        var url = process.env.VUE_APP_ONLINE_ORDERING_BY_BRANCH_URL + this.merchantCode;

        if (table_code) {
          url += '/QR/' + this.branch_code + "/" + table_code;
        } else {
          url += "/" + this.branch_code;
        }

        url += from + "?guest=1";

        window.open(url, '_self');
      }
    },
    gotoResetToInitialPasscode() {
      this.closeSnackbar()
      this.showLoader()
      AuthService.sendResetToInitialPasscode(this.form1.phone_number, this.form1.phone_code).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.isForgetPassword = false;
            this.isShowEnterPasscodeYourBirtday = true;
            // this.snackbar = 'success';
            // this.message = "Sent your pass code via phone number!";
            // this.setTimeOutNotification();
          } else {
            this.snackbar = 'danger'
            this.message = errorMessage(response.data.result.message)
            this.setTimeOutNotification()
          }
          this.hideLoader()
        },
        (error) => {
          this.snackbar = 'danger'
          this.message = errorMessage(error)
          this.hideLoader()
        }
      )
    },
    handleGetOneTimePasscode() {
      this.closeSnackbar()
      this.showLoader()
      AuthService.getOneTimePassCode(this.form1.phone_number, this.form1.phone_code).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.isForgetPassword = false;
            this.isShowEnterPasscodeYourBirtday = false;
            this.isShowEnterOneTimePasscode = true;
            this.snackbar = 'success';
            this.message = this.$t("signin.passcode_sent");
            this.setTimeOutNotification();
          } else {
            this.snackbar = 'danger'
            this.message = errorMessage(response.data.result.message)
            this.setTimeOutNotification()
          }
          this.hideLoader()
        },
        (error) => {
          this.snackbar = 'danger'
          this.message = errorMessage(error)
          this.hideLoader()
        }
      )
    },
    getCountriesForDropdown() {
      this.isLoadData = false;
      this.showLoader();
      MemberService.getCountriesForDropdown().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.countryData = response.data.data;
            this.isLoadData = true;
          } else {
            this.snackbar = "danger";
            this.message = errorMessage(response.data.result.message);
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = errorMessage(error);
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },
    openLegal(page) {
      this.$router.push({
        path: this.merchantCode + "/" + page,
        query: {
          branch_code: this.$route.query.branch_code ?? "",
          table_code: this.$route.query.table_code ?? "",
          from: this.$route.query.from ?? "",
        },
      });
    },
    handleBack() {
      if (this.isAlreadyPasscode && this.isForgetPassword) {
        this.isForgetPassword = false;
        this.isEnableGetOneTimePasscode = true;
        return;
      }
      this.backToPhone();
    },
    // Back to phone entry with every step flag at its data() default.
    backToPhone() {
      this.stopCount();
      this.closeSnackbar();
      this.isLoginNormal = true;
      this.isFirstLogin = false;
      this.isAlreadyPasscode = false;
      this.isPasscode = false;
      this.isConfirmPasscode = false;
      this.isOtp = false;
      this.isForgetPassword = false;
      this.isShowEnterPasscodeYourBirtday = false;
      this.isShowEnterOneTimePasscode = false;
      this.isEnableGetOneTimePasscode = true;
      this.form1.i_agree = false;
      this.form2.otp = "";
      this.form2.passcode = "";
      this.form2.confirmPasscode = "";
    },
    closeModal() {
      $(".btn-close").click()
    },
  },
};
</script>
<style scoped>
/* MBR006 Heritage Hearth sign-in */
/* Unscoped `* { font-family: Poppins }` in Landing / Store / RewardCatalogue hits every element;
   :where() keeps this at one attribute's specificity so class rules (titles, buttons) still win */
:where(:not(.material-icons-round)) {
  font-family: var(--mbr-font-body);
}

.mbr-signin.page-header {
  flex-direction: column;
  font-family: var(--mbr-font-body);
}

.mbr-signin__entry {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 440px;
  min-height: 100vh;
  min-height: 100dvh;
  margin: 0 auto;
  background: var(--mbr-color-canvas);
}

.mbr-signin__hero {
  position: relative;
  flex: 1 0 auto;
  min-height: 220px;
  overflow: hidden;
  background-color: var(--mbr-color-primary);
  background-image:
    radial-gradient(circle at 85% 12%, rgba(var(--mbr-color-surface-rgb), 0.14), transparent 55%),
    linear-gradient(180deg, rgba(var(--mbr-color-shadow-rgb), 0.45) 0%, rgba(var(--mbr-color-shadow-rgb), 0.08) 55%, rgba(var(--mbr-color-shadow-rgb), 0.3) 100%);
}

/* MBR133: the merchant's picture sits under the same gradients so the brand row stays legible;
   a picture that fails to load just drops out and leaves the primary colour. */
.mbr-signin__hero--image {
  background-image:
    radial-gradient(circle at 85% 12%, rgba(var(--mbr-color-surface-rgb), 0.14), transparent 55%),
    linear-gradient(180deg, rgba(var(--mbr-color-shadow-rgb), 0.45) 0%, rgba(var(--mbr-color-shadow-rgb), 0.08) 55%, rgba(var(--mbr-color-shadow-rgb), 0.3) 100%),
    var(--mbr-login-bg);
  background-size: auto, auto, cover;
  background-position: center, center, center;
  background-repeat: no-repeat;
}

.mbr-signin__brand {
  position: absolute;
  top: 48px;
  left: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.mbr-signin__logo {
  flex: none;
  width: 44px;
  height: 44px;
  object-fit: contain;
  background: var(--mbr-color-surface);
  border: 1px solid rgba(var(--mbr-color-surface-rgb), 0.2);
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(var(--mbr-color-shadow-rgb), 0.18);
}

.mbr-signin__brand-name {
  display: block;
  font-family: var(--mbr-font-headline);
  font-size: 18px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.01em;
  color: #fff;
}

.mbr-signin__brand-tag {
  display: block;
  font-size: 10px;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--mbr-color-peach);
}

.mbr-signin__sheet {
  position: relative;
  margin-top: -24px;
  padding: 28px 24px 32px;
  background: var(--mbr-color-surface);
  border-top: 1px solid rgba(var(--mbr-color-outline-rgb), 0.4);
  border-radius: 32px 32px 0 0;
  box-shadow: 0 -8px 30px rgba(var(--mbr-color-primary-rgb), 0.12);
}

.mbr-signin__handle {
  display: block;
  width: 40px;
  height: 4px;
  margin: -12px auto 16px;
  border-radius: var(--mbr-radius-full);
  background: var(--mbr-color-outline);
}

.mbr-signin__label {
  display: block;
  margin: 0 0 8px;
  font-size: var(--mbr-label-caps-size);
  font-weight: var(--mbr-label-caps-weight);
  line-height: var(--mbr-label-caps-line);
  letter-spacing: var(--mbr-label-caps-tracking);
  text-transform: uppercase;
  color: var(--mbr-color-ink-muted);
}

.mbr-signin__phone {
  display: flex;
  align-items: center;
  height: 64px;
  padding: 0 16px;
  background: var(--mbr-color-surface);
  border: 1.5px solid var(--mbr-color-outline);
  border-radius: 20px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.mbr-signin__phone:focus-within {
  border-color: var(--mbr-color-primary);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--mbr-color-primary) 15%, transparent);
}

.mbr-signin__code {
  flex: none;
  max-width: 96px;
  height: 100%;
  padding: 0 22px 0 0;
  border: 0;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%238C7877' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19.5 8.25l-7.5 7.5-7.5-7.5'/%3E%3C/svg%3E")
    no-repeat right center / 16px;
  appearance: none;
  font-family: var(--mbr-font-body);
  font-size: 16px;
  font-weight: 700;
  color: var(--mbr-color-ink-headline);
  cursor: pointer;
}

.mbr-signin__code:focus {
  outline: none;
}

.mbr-signin__code:disabled {
  padding-right: 4px;
  background-image: none;
  opacity: 1;
  cursor: default;
}

.mbr-signin__divider {
  flex: none;
  width: 1px;
  height: 28px;
  margin: 0 12px 0 10px;
  background: var(--mbr-color-outline);
}

.mbr-signin__number {
  flex: 1;
  min-width: 0;
  height: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  background: transparent;
  font-family: var(--mbr-font-body);
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: var(--mbr-color-ink-headline);
}

.mbr-signin__hint {
  margin: 8px 0 0;
  font-size: 12px;
  line-height: 16px;
  color: var(--mbr-color-ink-muted);
}

.mbr-signin__cta {
  margin-top: 16px;
}

.mbr-signin__cta .material-icons-round {
  font-size: 20px;
}

.mbr-signin__guest {
  display: block;
  margin: 12px auto 0;
  padding: 4px 8px;
  border: 0;
  background: none;
  font-size: 14px;
  font-weight: 600;
  color: var(--mbr-color-label);
  text-decoration: underline;
  text-underline-offset: 4px;
}

.mbr-signin__or {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 20px 0 16px;
  font-size: 11px;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--mbr-color-ink-muted);
}

.mbr-signin__or::before,
.mbr-signin__or::after {
  content: "";
  flex: 1;
  height: 1px;
  background: var(--mbr-color-outline);
}

.mbr-signin__legal {
  margin: 24px 0 0;
  text-align: center;
  font-size: 11px;
  line-height: 16px;
  color: var(--mbr-color-ink-muted);
}

.mbr-signin__link {
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  font-weight: 600;
  color: var(--mbr-color-ink-secondary);
  text-decoration: underline;
}

/* Passcode / OTP / reset steps */
.mbr-signin__step {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 440px;
  min-height: 100vh;
  min-height: 100dvh;
  margin: 0 auto;
  padding: 24px 24px 40px;
  background: var(--mbr-color-canvas);
  /* Passcode steps keep the design canvas; brand colours follow the theme tokens (MBR128) */
  --mbr-color-canvas: #FFF8F7;
}

.mbr-signin__keypad {
  flex: none;
}

.mbr-signin__topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-top: 24px;
}

.mbr-signin__back {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  background: var(--mbr-color-surface);
  border: 1px solid var(--mbr-color-outline);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-ink-headline);
  box-shadow: var(--mbr-shadow-card);
  transition: transform 0.15s ease;
}

.mbr-signin__back:active {
  transform: scale(0.95);
}

.mbr-signin__back .material-icons-round {
  font-size: 26px;
}

.mbr-signin__who {
  text-align: right;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: var(--mbr-color-ink-muted);
}

.mbr-signin__who span {
  display: block;
}

.mbr-signin__change {
  padding: 0;
  border: 0;
  background: none;
  font-size: 12px;
  font-weight: 700;
  color: var(--mbr-color-label);
  text-decoration: underline;
  text-underline-offset: 2px;
}

/* MBR011: no logo tile above the title — bias the centred group upward so the
   headline sits clear of the keypad instead of floating mid-screen */
.mbr-signin__body {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 0 0 56px;
  text-align: center;
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-signin__title {
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: 28px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--mbr-color-ink-headline);
}

.mbr-signin__title--sm {
  font-size: var(--mbr-headline-md-size);
  line-height: var(--mbr-headline-md-line);
}

.mbr-signin__sub {
  margin: 6px 0 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: var(--mbr-color-ink-muted);
}

.mbr-signin__form {
  margin: 0;
}

.mbr-signin__pin {
  display: flex;
  justify-content: center;
}

/* Outranks the unscoped `.otp-input` underline rules in ChangePasscode / ForgotPassword */
.mbr-signin__pin :deep(.otp-input) {
  width: 64px;
  height: 72px;
  margin: 0 6px;
  padding: 0;
  background: var(--mbr-color-surface);
  border: 1px solid var(--mbr-color-outline);
  border-radius: var(--mbr-radius-lg) !important;
  box-shadow: 0 1px 2px rgba(var(--mbr-color-primary-rgb), 0.05);
  font-family: var(--mbr-font-headline);
  font-size: 28px;
  font-weight: 700;
  text-align: center;
  color: var(--mbr-color-ink-headline);
  caret-color: var(--mbr-color-primary);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.mbr-signin__pin :deep(.otp-input:focus) {
  outline: none;
  border: 2px solid var(--mbr-color-primary);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--mbr-color-primary) 15%, transparent);
}

.mbr-signin__textlink {
  padding: 0;
  border: 0;
  background: none;
  font-size: 14px;
  font-weight: 600;
  color: var(--mbr-color-label);
  text-decoration: underline;
  text-underline-offset: 4px;
}

.mbr-signin__countdown {
  padding: 2px 10px;
  background: var(--mbr-color-tint);
  border-radius: var(--mbr-radius-full);
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  font-variant-numeric: tabular-nums;
  color: var(--mbr-color-ink-secondary);
}

.mbr-signin__resend {
  font-size: 14px;
}

/* MBR018 reset step — member_app_UI/reset_passcode_UI */
.mbr-signin__body--top {
  justify-content: flex-start;
  gap: 0;
  /* reset step keeps its own spacing — it never showed the logo tile */
  padding: 20px 0 24px;
}

.mbr-signin__emblem {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.mbr-signin__emblem-glow {
  position: absolute;
  width: 96px;
  height: 96px;
  border-radius: var(--mbr-radius-full);
  background: color-mix(in srgb, var(--mbr-color-peach) 70%, transparent);
  filter: blur(24px);
}

.mbr-signin__emblem-frame {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 82px;
  height: 82px;
  padding: 12px;
  background: linear-gradient(180deg, var(--mbr-color-surface), var(--mbr-color-tint));
  border: 1px solid #F2DEDB;
  border-radius: 22px;
  box-shadow: 0 8px 24px -4px rgba(var(--mbr-color-primary-rgb), 0.08), 0 2px 6px -1px rgba(var(--mbr-color-primary-rgb), 0.04);
}

.mbr-signin__emblem-core {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  background:
    radial-gradient(color-mix(in srgb, var(--mbr-color-peach) 10%, transparent) 1px, transparent 1px) 0 0 / 6px 6px,
    linear-gradient(135deg, var(--mbr-color-primary), #2C0B0B);
  box-shadow: inset 0 2px 4px rgba(var(--mbr-color-shadow-rgb), 0.25);
  color: var(--mbr-color-peach);
}

.mbr-signin__emblem-core svg {
  width: 28px;
  height: 28px;
}

.mbr-signin__reset-head {
  margin-bottom: 32px;
  padding: 0 4px;
}

.mbr-signin__reset-title {
  font-size: 26px;
  color: var(--mbr-color-primary);
}

.mbr-signin__reset-sub {
  max-width: 280px;
  margin: 8px auto 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.625;
  color: color-mix(in srgb, var(--mbr-color-primary) 75%, transparent);
}

.mbr-signin__reset-actions {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.mbr-signin__reset-cta {
  gap: 8px;
  box-shadow: 0 10px 25px -5px rgba(var(--mbr-color-primary-rgb), 0.28), 0 4px 10px -2px rgba(var(--mbr-color-primary-rgb), 0.15);
}

.mbr-signin__reset-cta .material-icons-round {
  font-size: 20px;
  color: var(--mbr-color-peach);
}

.mbr-signin__ddmm {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: var(--mbr-color-tint);
  border: 1px solid color-mix(in srgb, #F2DEDB 80%, transparent);
  border-radius: var(--mbr-radius-lg);
  box-shadow: 0 1px 2px rgba(var(--mbr-color-primary-rgb), 0.05);
  text-align: left;
}

.mbr-signin__ddmm-icon {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-top: 2px;
  background: color-mix(in srgb, var(--mbr-color-peach) 90%, transparent);
  border: 1px solid color-mix(in srgb, var(--mbr-color-primary) 10%, transparent);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-primary);
}

.mbr-signin__ddmm-icon svg {
  width: 14px;
  height: 14px;
}

.mbr-signin__ddmm-text {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.375;
  color: color-mix(in srgb, var(--mbr-color-primary) 85%, transparent);
}

/* size set on <p> itself: Material Dashboard's global `p` font-size beats inheritance */
.mbr-signin__ddmm-text p {
  margin: 0 0 2px;
  font-size: 12px;
  line-height: 1.375;
}

.mbr-signin__ddmm-text strong {
  font-weight: 700;
  color: var(--mbr-color-primary);
}

.mbr-signin__ddmm-example.mbr-signin__ddmm-example {
  margin: 8px 0 0;
  padding-top: 8px;
  border-top: 1px solid color-mix(in srgb, var(--mbr-color-primary) 10%, transparent);
  font-size: 11px;
  color: color-mix(in srgb, var(--mbr-color-primary) 70%, transparent);
}

.mbr-signin__ddmm-code {
  padding: 2px 6px;
  background: rgba(var(--mbr-color-surface-rgb), 0.7);
  border: 1px solid #F2DEDB;
  border-radius: 4px;
  font-family: var(--mbr-font-headline);
  font-weight: 700;
  color: var(--mbr-color-primary);
}

.mbr-signin__support {
  padding: 32px 0 12px;
  text-align: center;
}

.mbr-signin__support .mbr-signin__support-brand {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--mbr-color-primary);
  opacity: 0.4;
}

.mbr-signin__support-brand span {
  width: 6px;
  height: 6px;
  border-radius: var(--mbr-radius-full);
  background: var(--mbr-color-primary);
}

.mbr-signin__note {
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 16px;
  background: var(--mbr-color-tint);
  border: 1px solid color-mix(in srgb, var(--mbr-color-outline) 60%, transparent);
  border-radius: var(--mbr-radius-lg);
  text-align: left;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-signin__note .material-icons-round {
  margin-top: 1px;
  font-size: 16px;
  color: var(--mbr-color-primary);
}

.mbr-signin__inline {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 4px 10px;
  font-size: 12px;
  color: var(--mbr-color-ink-muted);
}

.mbr-signin__inline .mbr-signin__textlink {
  font-size: 12px;
}
</style>
